import React from "react";

const BlogHeroSkeleton = () => {
  return (
    <div className="relative bg-white pb-4 pt-9 lg:pb-8 lg:pt-24">
      <div className="container mx-auto px-8">
        <div className="sm:mx-auto sm:max-w-screen-2xl sm:px-4 lg:px-0">
          <div className="flex flex-col items-center justify-center gap-8 lg:mb-0 lg:flex-row">
            <div className="relative w-full">
              {/* Main heading skeleton */}
              <div className="mb-2 flex justify-center">
                <div className="h-8 w-full max-w-4xl animate-pulse rounded-lg bg-gray-200 sm:h-10 lg:h-12"></div>
              </div>
              {/* Description skeleton */}
              <div className="mx-auto flex justify-center lg:max-w-[85%]">
                <div className="h-4 w-full max-w-3xl animate-pulse rounded-lg bg-gray-200 lg:h-6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogHeroSkeleton;
